<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"
        (click)="closeModal.emit()"></div>

    <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
        <div class="pointer-events-auto w-screen max-w-5xl">
            <div class="flex h-full flex-col overflow-y-auto bg-white dark:bg-zinc-950 shadow-xl">
                <div class="px-6 py-2 border-b border-zinc-950/10 dark:border-white/10">
                    <div class="flex items-start justify-between">
                        <h2 class="heading" id="slide-over-title">{{reference.title}} Profile</h2>
                        <button type="button" (click)="closeModal.emit()"
                            class="rounded-md text-zinc-500 hover:text-zinc-700 dark:text-white dark:hover:text-zinc-300 focus:ring-2 focus:ring-primary">
                            <span class="sr-only">Close panel</span>
                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                <div *ngIf="profile" class="flex-1 overflow-y-auto bg-zinc-50 dark:bg-zinc-900">
                    <header class="bg-gradient-to-r from-sky-800 to-cyan-600 py-16"></header>
                    <main class="-mt-24 pb-8">
                        <div class="mx-auto px-4 sm:px-6 lg:px-8">
                            <div class="grid grid-cols-1 items-start gap-4 lg:grid-cols-3 lg:gap-8">

                                <div class="grid grid-cols-1 gap-4 lg:col-span-2">
                                    <!-- Profile -->
                                    <section class="overflow-hidden rounded-lg bg-white dark:bg-zinc-950 shadow p-6">
                                        <div class="sm:flex sm:items-center sm:space-x-5">
                                            <div class="flex-shrink-0">
                                                <a *ngIf="profile.image; else initial" [href]="profile.image" target="_blank" rel="noopener">
                                                    <img class="mx-auto h-20 w-20 rounded-full object-cover" [src]="profile.image" [alt]="profile.label" />
                                                </a>
                                                <ng-template #initial>
                                                    <div class="mx-auto h-20 w-20 rounded-full bg-zinc-200 dark:bg-zinc-800 flex items-center justify-center text-2xl font-bold text-main-dark">
                                                        {{profile.label?.charAt(0) | uppercase}}
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <div class="mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left">
                                                <p class="text-xl font-bold text-main-dark sm:text-2xl inline-flex flex-wrap items-center gap-2">
                                                    {{profile.label | titlecase}}
                                                    <span [ngClass]="profile.status === 'Active' ? 'badge-success' : 'badge-danger'">{{profile.status}}</span>
                                                </p>
                                                <p class="text-sm font-medium text-main-light">{{profile.title}}<span *ngIf="profile.detail"> · {{profile.detail}}</span></p>
                                            </div>
                                        </div>
                                    </section>

                                    <!-- Details -->
                                    <section class="overflow-hidden rounded-lg bg-white dark:bg-zinc-950 shadow p-6">
                                        <div class="grid sm:grid-cols-2 gap-6">
                                            <dl *ngFor="let column of detailColumns" class="divide-y divide-zinc-950/10 dark:divide-white/10">
                                                <div *ngFor="let detail of column" class="flex justify-between gap-4 py-3 text-xs font-medium">
                                                    <dt class="text-main-light">{{detail.label}}</dt>
                                                    <dd class="text-main-dark text-right break-all">{{detail.value || '-'}}</dd>
                                                </div>
                                            </dl>
                                        </div>
                                    </section>
                                </div>

                                <!-- Documents -->
                                <section class="overflow-hidden rounded-lg bg-white dark:bg-zinc-950 shadow p-6">
                                    <h2 class="text-base font-medium text-main-dark">Documents</h2>
                                    <ul class="mt-3 divide-y divide-zinc-950/10 dark:divide-white/10">
                                        <li *ngFor="let document of profile.documents" class="flex items-center justify-between gap-2 py-3 text-xs font-medium">
                                            <span class="text-main-light">{{document.label}}</span>
                                            <a [href]="document.url" target="_blank" rel="noopener" class="underline text-main-primary">View</a>
                                        </li>
                                    </ul>
                                    <p *ngIf="!profile.documents.length" class="mt-3 text-xs text-main-light">No documents</p>
                                </section>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    </div>
</div>
